export default __webpack_public_path__ + "static/media/border-radius-bottom-left.17e3ade6.svg";